const EMPTY_COMMENTARY_TEXT = 'Add commentary...';
const EMPTY_SUMMARY_EXPRESSIONS = ['<p></p>', '<p><br></p>', ''];

const STRATEGY_TYPES = {
  FACILITIES: 'Facility',
  PRODUCTION: 'ProductionEquipment',
  PEOPLE: 'People',
  IT_RESOURCES: 'ITResource',
  SUPPLY_CHAIN: 'SupplyChain',
  OTHER_CONSIDERATION: 'OtherConsideration',
};

const STRATEGY_MODELS = {
  FACILITIES: 'strategyFacility',
  PRODUCTION: 'strategyProductionEquipment',
  PEOPLE: 'strategyPeople',
  IT_RESOURCES: 'iTResource',
  SUPPLY_CHAIN: 'supplyChain',
};

export {
  EMPTY_COMMENTARY_TEXT,
  EMPTY_SUMMARY_EXPRESSIONS,
  STRATEGY_TYPES,
  STRATEGY_MODELS,
};
